/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
// const fs = require('fs');
// const path = require('path');

export const generateNutrientData = (nutrientsData,docIds) => {
    const row_label_data = [];
    const row_data = {};

    Object.values(docIds).forEach((docId) => {

        const result = nutrientsData.results[docId];
        console.log("result", result);
        const doc = result.docs[0];
        doc.topics?.forEach((topic) => {
            const { name, sectionKey, unit } = topic.nutrientKey;
            const isSubtopic = !!topic.subtopics;

            // Add to row_label_data
            if (!row_label_data.some((row) => row[2] === sectionKey)) {
                row_label_data.push([isSubtopic, `<strong>${name}</strong>${unit ? `, ${unit}` : ''}`, sectionKey]);
            }

            // Initialize row_data for this sectionKey if not already present
            if (!row_data[sectionKey]) {
                row_data[sectionKey] = [];
            }

            // Add values for this sectionKey
            const content = doc.content?.find((item) => item.sectionKey === sectionKey);
            if (content) {
                const { perLiter = '-', per100Cal = '-' } = content.value;
                //If perLiter or per100Cal is empty, set it to a space to avoid table border collapse
                const formattedPerLiter = perLiter === '' ? " " : perLiter;
                const formattedper100Cal = per100Cal === '' ? " " : per100Cal;
                row_data[sectionKey].push([formattedPerLiter, formattedper100Cal]);
            } else {
                row_data[sectionKey].push(['-', '-']);
            }

            // Process subtopics if present
            if (isSubtopic) {
                topic.subtopics.forEach((subtopic) => {
                    const { name: subName, sectionKey: subSectionKey, unit: subUnit } = subtopic;

                    // Add to row_label_data
                    if (!row_label_data.some((row) => row[2] === subSectionKey)) {
                        row_label_data.push([true, `&nbsp;&nbsp;&nbsp;${subName}${subUnit ? `, ${subUnit}` : ''}`, subSectionKey]);
                    }

                    // Initialize row_data for this subSectionKey if not already present
                    if (!row_data[subSectionKey]) {
                        row_data[subSectionKey] = [];
                    }

                    // Add values for this subSectionKey
                    const subContent = doc.content.find((item) => item.sectionKey === subSectionKey);
                    if (subContent) {
                        const { perLiter = '-', per100Cal = '-' } = subContent.value;
                        row_data[subSectionKey].push([perLiter, per100Cal]);
                    } else {
                        row_data[subSectionKey].push(['-', '-']);
                    }
                });
            }
        });
    });

    return { row_label_data, row_data };
};
